import axios from '@/axios.js'

const state = () => ({
  tasks: [],
  saldo: {}
})

const mutations = {
  SET_NERACA (state, payload) {
    state.tasks = payload.tasks
    state.saldo = payload.saldo
  },
}

const actions = {
  fetchNeraca ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/neraca`)
        .then((response) => {
          commit('SET_NERACA', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
}

export default {
  isRegistered: false,
  namespaced: true,
  state,
  actions,
  mutations
}